<script setup lang="ts">
import { useAttrs } from "vue";
import { Input } from "@/components/ui/input";

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();

defineProps<{
  modelValue?: string | number;
}>();

const emit = defineEmits<{
  (event: "update:modelValue", value: string | number): void;
}>();
</script>

<template>
  <div class="relative">
    <Input
      v-bind="attrs"
      :model-value="modelValue"
      class="appearance-none"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </div>
</template>
